/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Copy_FailedInputs */

const en_settings_apikeys_copy_failed = /** @type {(inputs: Settings_Apikeys_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy, please copy manually`)
};

const zh_settings_apikeys_copy_failed = /** @type {(inputs: Settings_Apikeys_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制失败，请手动复制`)
};

/**
* | output |
* | --- |
* | "Failed to copy, please copy manually" |
*
* @param {Settings_Apikeys_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_copy_failed = /** @type {((inputs?: Settings_Apikeys_Copy_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Copy_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_copy_failed(inputs)
	return zh_settings_apikeys_copy_failed(inputs)
});
export { settings_apikeys_copy_failed as "settings.apikeys.copy_failed" }